module.exports = __webpack_public_path__ + "static/media/logo.e53e4b46.png";